module.exports = __webpack_public_path__ + "img/di16.811cee70.png";